"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const { defineProperty } = Object;
const setter = (name, defaultValue) => {
    return function (target, propertyKey) {
        const fnDesc = mobx_1.action.bound(target, name, {
            value: function (value) {
                const shouldUseValue = value || (typeof value === 'number' && Number.isInteger(value)) || typeof value === 'boolean' || value !== 'undefined';
                this[propertyKey] = shouldUseValue ? value : defaultValue;
            }
        });
        defineProperty(target, name, fnDesc);
    };
};
exports.setter = setter;
//# sourceMappingURL=setter.js.map